
/**
* src/connects/diary-content.js
* 
*/

import { pushRoute } from '../actions/route'
import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import { translate } from 'react-i18next'

export const mapDispatchToProps = (dispatch)=> {
  return {
    showGoogleDoc:  (url)=> {
      dispatch(actions.openRightSidePage('google_doc', { url: url }, true))
    },

    openGambaURL: (url)=> {
      const paths = url.replace(/^.+groups\//, '').split('/')
      var kpi_id, diary_id, chat_room_id, match
      var group_id = parseInt(paths[0])
      if (paths.length == 2 && paths[1] == 'timeline') {
        pushRoute('group_timeline', { group_id })
      }
      else if (paths.length == 1 && paths[0] == 'home') {
        pushRoute('home_group')
      }
      else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3])
        dispatch(actions.openRightSidePage('kpi_chart', { group_id, kpi_id }))
      }
      else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/)) ||
               paths.length == 2 && (match = paths[1].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1])
        dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }))
      }
      else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2])
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id }))
      }
    },
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/diary-content.js